import type { AfterViewInit, OnDestroy } from '@angular/core';
import { Directive, ElementRef, NgZone } from '@angular/core';
import { Share } from '@capacitor/share';
import { Pwa } from '@freelancer/pwa';
import { TimeUtils } from '@freelancer/time-utils';
import type { Timer } from '@freelancer/time-utils/testing';

@Directive({
  selector: `[flNativeCopy]`,
})
export class NativeCopyDirective implements AfterViewInit, OnDestroy {
  longPressTimer: Timer;
  readonly LONG_PRESS_DELAY = 500;

  private get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  constructor(
    private elementRef: ElementRef,
    private ngZone: NgZone,
    private pwa: Pwa,
    private timeUtils: TimeUtils,
  ) {}

  longPressShowShareMenu = (): void => {
    this.longPressTimer = this.timeUtils.setTimeout(async () => {
      await Share.share({
        text: this.element.innerText,
      }).catch(error => {
        // User changes their mind. Ignore the error.
        if (error.message === 'Share canceled') {
          return;
        }
        throw error;
      });
    }, this.LONG_PRESS_DELAY);
  };

  longPressClearTimeout = (): void => {
    clearTimeout(this.longPressTimer);
  };

  ngAfterViewInit(): void {
    if (this.pwa.isNative()) {
      this.ngZone.runOutsideAngular(() => {
        this.element.addEventListener(
          'touchstart',
          this.longPressShowShareMenu,
        );
        this.element.addEventListener('touchend', this.longPressClearTimeout);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.pwa.isNative()) {
      this.ngZone.runOutsideAngular(() => {
        this.element.removeEventListener(
          'touchstart',
          this.longPressShowShareMenu,
        );
        this.element.removeEventListener(
          'touchend',
          this.longPressClearTimeout,
        );
      });
    }
  }
}
